<template>
  <div class="history">
    <div class="navbar">
      <div @click="$router.go(-1)">
        <back />
      </div>
      <div>Pendaftaran Kelas Prioritas</div>
    </div>

    <div class="loading" style="display: flex;justify-content: center;margin-top: 100px;" v-if="isFetching">
      <loading />
    </div>

    <div class="body" v-else>

      <div class="registered" v-if="param.status_absen == 'PRIORITAS'">
        <div class="prioritas" style="text-align: center;">
          <p>
            <img
              src="data:image/png;base64,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"
              alt="guarantee">
          </p>
          <h3>Anda sudah terdaftar di Kelas Prioritas</h3>
        </div>

        <div class="history-pembayaran"
          style="border: 1px solid #ccc;margin: 30px 0 30px;padding: 15px;border-radius: 6px;">
          <p style="margin: 0;color: #333;">
            <b>History Pembayaran</b>
          </p>

          <div class="mt" style="text-align: center;font-size: 14px;margin: 40px 0;" v-if="historyBayar.length <= 0">
            <p style="color: #333;">Anda belum melakukan pembayaran untuk Kelas Prioritas.<br />
              Silakan segera melakukan pembayaran</p>
          </div>

          <ul style="margin: 0;padding:0;list-style: none;margin-top: 30px;" v-if="historyBayar.length > 0">
            <li v-for="item, index in historyBayar" :key="index"
              style="display: flex;justify-content: space-between;font-size: 14px;padding: 15px 0;border-bottom: 1px solid #ccc;">
              <div>{{ moment(item.tgl_bayar).format('DD MMM YYYY') }}</div>
              <div>
                <b>Rp {{ item.jumlah_bayar_fix | number }}</b>
              </div>
            </li>
          </ul>
        </div>

        <div class="form-upload-bukti">
          <p>
            <b>Upload Bukti Pembayaran</b>
          </p>
          <form @submit.prevent="upload()">
            <div class="form-group">
              <label>Tgl Bayar</label>
              <input type="date" v-model="param.tgl_bayar" required>
            </div>
            <div class="form-group">
              <label>Jumlah Bayar</label>
              <input type="number" v-model="param.jumlah_bayar" required>
            </div>
            <div class="form-group">
              <label>Pilih bukti pembayaran</label>
              <input type="file" accept="image/jpeg" @change="previewFile">
            </div>
            <button type="submit" class="btn btn-primary" :disabled="loadingUpload">Upload Bukti Pembayaran</button>
          </form>
        </div>
      </div>

      <form @submit.prevent="daftar()" style="margin-top: 10px;" v-if="param.status_absen != 'PRIORITAS'">
        <p style="margin: 0 0 30px;font-size: 14px;">
          Silakan isi formulir berikut untuk mendaftar Kelas Prioritas
        </p>
        <div class="form-group">
          <label>Nama Lengkap</label>
          <input type="text" disabled v-model="param.nama_lengkap" />
        </div>
        <div class="form-group">
          <label>No Daftar</label>
          <input type="text" disabled :value="param.no_daftar + param.prefix_daftar" />
        </div>
        <div class="form-group">
          <label>Angkatan</label>
          <input type="text" disabled :value="param.angkatan" />
        </div>
        <div class="form-group">
          <label>Jurusan</label>
          <input type="text" disabled :value="param.jurusan" />
        </div>
        <div class="form-group">
          <label>Kampus</label>
          <input type="text" disabled :value="param.kampus" />
        </div>
        <div class="form-group">
          <label>Akun Instagram</label>
          <input type="text" v-model="param.instagram" required />
        </div>
        <div class="form-group">
          <label>Akun Tiktok</label>
          <input type="text" v-model="param.tiktok" required />
        </div>
        <div class="form-group">
          <label>Email</label>
          <input type="email" v-model="param.email" />
        </div>
        <div class="form-group">
          <label>No Whatsapp</label>
          <input type="tel" v-model="param.no_hp_siswa" />
        </div>
        <div class="form-group">
          <label>Nama Orangtua / Wali</label>
          <input type="text" v-model="param.nama_orangtua" />
        </div>
        <div class="form-group">
          <label>No Whatsapp Orangtua / Wali</label>
          <input type="tel" v-model="param.no_hp_orangtua" />
        </div>

        <div class="checkbox" style="margin-bottom: 20px;">
          <label style="font-size: 14px;cursor: pointer;">
            <input type="checkbox" v-model="setuju">
            Saya telah menerima penjelasan tentang Kelas Prioritas
            dan menyetujui ketentuan Kelas Prioritas
          </label>
        </div>

        <div>
          <button type="submit" class="btn btn-primary" :disabled="!setuju || loading">
            DAFTAR KELAS PRIORITAS
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Back from "./icons/Back.vue";
import Loading from "./icons/Loading.vue";

import axios from "axios";
import * as api from "../api/Api";
import moment from "moment";

export default {
  name: "Search",
  components: {
    Back,
    Loading,
  },
  data() {
    return {
      isFetching: false,
      loading: false,
      loadingUpload: false,

      historyBayar: [],

      setuju: false,
      param: {},
      file: null,
    };
  },
  methods: {
    moment,
    to(item) {
      setTimeout(() => {
        this.$router.push("/history/" + item.id);
      }, 150);
    },
    async load() {
      this.isFetching = true;
      const r = await api.get(`/v1/siswa/ProfilController/get?id=${this.$store.state.settings.user.id}`)
      this.param = r.data;

      const historyBayar = await api.get(`/v1/siswa/KelasPrioritasController/historyBayar?id=${this.param.id}`)
      if (historyBayar.valid) {
        this.historyBayar = historyBayar.data;
      }

      this.isFetching = false;
    },
    async daftar() {
      this.loading = true;

      const r = await api.post(`/v1/siswa/KelasPrioritasController/daftar`, this.param)
      await this.load();

      this.loading = false;
    },
    previewFile(e) {
      const [file] = e.target.files;
      this.file = file;
    },
    upload() {
      if (!this.file) {
        alert("Silakan pilih bukti pembayaran");
        return;
      }

      const data = new FormData();
      data.append("id", this.param.id);
      data.append("tgl_bayar", this.param.tgl_bayar);
      data.append("jumlah_bayar", this.param.jumlah_bayar);
      data.append("bukti_bayar", this.file);

      const config = {
        onUploadProgress: function (progressEvent) {
          let percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
        },
      };

      this.loadingUpload = true;

      axios
        .post(
          "https://api.pspp-integrated.com/api/v1/siswa/KelasPrioritasController/upload",
          data,
          config
        )
        .then(function (res) {
          location.reload();
        })
        .catch(function (err) {
          this.loadingUpload = false;
          console.log(err.message);
        });
    }
  },
  mounted() {
    this.load();
  },
};
</script>

<style scoped lang="scss">
.navbar {
  background: #fff;
  color: #333;
  padding: 15px;
  font-weight: 600;
  display: grid;
  grid-template-columns: 40px 1fr;
  border-bottom: 1px solid #ccc;
}

.body {
  padding: 20px;
}
</style>